export default `---
slug: tech-entrepreneurship
title: "Tech Entrepreneurship"
year: 2020
category: university
featured: false
tags: [Entrepreneurship, Business Case, Drone, Sustainability]
thumbnail: /images/projects/5_Actea_drone.png
description: "Actea: a drone and autonomous docking station concept to clean Milan's Navigli rivers — the startup idea that was ahead of its time."
relatedLinks:
  - label: "Bachelor at Politecnico di Milano"
    href: /career/bachelor-polimi
---

![Actea Drone](/images/projects/5_Actea_drone.png)

This project was the deliverable for the class "High Tech Entrepreneurship".
The goal was to create a business model for a tech startup, explore the market, and build the business case for an investor pitch.
Once again, I was in a team with Edoardo *The Usual*, and also Guido, Barbara and Petar.

We started from the observation that Milan's rivers (*i Navigli*) have a lot of trash floating in them, and our desire to clean them up and help the environment.
We did all the needed research to understand the amount of pollution in the target rivers, and we also analyzed the existing solutions.

![Actea stations](/images/projects/5_Actea_stations.png)

We then designed a solution made of a remotely controlled floating drone and an automatic station for the drone to dock, offload and recharge.
We did a complete analysis of the production costs, as well as other costs and potential revenues.
Back in those days, we were still naive, so we decided to go for a non-profit model - even though the numbers showed potential for profit.
I remember we worked very hard for this project, and we were extremely proud of the idea and the work we have done.
The only negative memory of this project is the final evaluation, lower than our expectations, and lower than some other projects that were complete trash.

*In full disclosure, we were evaluated by one of the greatest entrepreneueral minds of our generation, a guy that opened a **paper printing shop** in Mexico... so who cares*

Anyway, we had a lot of fun and I learnt a lot from this project, and I still cherish the memory of it.
Also, nowadays there are multiple startups that are doing exactly what we proposed, which is the biggest possible validation we could get for our idea.

P.S. Shout out to "Lo Zio Rova" for the fantastic renders of the Actea drone and the stations!
`;
